import React from 'react';
import { Accordion } from './Accordion';
import { objections } from '../data/content';
export function Objections() {
  const data = objections.map(o => ({
    title: o.q,
    items: [o.a]
  }));
  return <section className="px-5 py-8" aria-labelledby="objeciones-title" data-id="element-163" data-mp="mjfxk9pt1mth">
      <h2 id="objeciones-title" className="text-center font-display text-[22px] text-[#16302a]" data-id="element-164" data-mp="hkuzogy0zf87">
        Dudas antes de empezar
      </h2>
      <div className="mt-5" data-id="element-165" data-mp="cmtglw0lnfwq">
        <Accordion data={data} defaultOpen={null} data-id="element-166" data-mp="cn2vang720n4" />
      </div>
    </section>;
}